import { takeLatest, call } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { LanguageType } from '../../../../types';
import { changeLanguageInUrl } from '../../../../utils/changeLanguageInUrl';
import { erpSystemActions } from './index';

export function* changeLanguage(action: PayloadAction<LanguageType>) {
  const languageInUrl = window.location.pathname.split('/')[1] as LanguageType;
  if (languageInUrl !== action.payload) {
    // we redirect to new url, and then app will reload and language will be set from initialState
    yield call(changeLanguageInUrl, action.payload);
  }
}

export function* changeLanguageSaga() {
  yield takeLatest(erpSystemActions.changeLanguage.type, changeLanguage);
}
